import InfoPage from '@/components/InfoPage';

const QuemSomos = () => {
  return (
    <InfoPage title="Quem Somos">
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Nossa Missão</h2>
          <p className="text-gray-700 leading-relaxed">
            Proporcionar um aplicativo gratuito e funcional com o objetivo de ser <strong>SEMPRE GRÁTIS</strong>. Pois nós acreditamos na individualidade do empreendedorismo e no futuro do livre mercado da concorrência.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            Revolucionar a experiência de estacionamento no Brasil, conectando motoristas a vagas disponíveis de forma rápida, segura e econômica. Facilitando a mobilidade urbana, tornando a busca e o gerenciamento de vagas de estacionamento uma experiência tranquila, segura e eficiente para todos e transformar a forma de encontrar uma vaga em uma simples etapa do dia-a-dia.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#831D1C' }}>Nossa Visão</h2>
          <p className="text-gray-700 leading-relaxed">
            Ser a plataforma líder e mais confiável em soluções para estacionamentos no Brasil, reconhecida pela inovação, qualidade de serviço e impacto positivo na vida das pessoas e na organização das cidades. Acreditamos que encontrar uma vaga não deve ser uma dor de cabeça. Por isso, criamos uma plataforma que facilita a vida de milhões de brasileiros todos os dias.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#009440' }}>Nossa História</h2>
          <p className="text-gray-700 leading-relaxed">
            O ParkingSpot nasceu da frustração comum de milhões de brasileiros: perder tempo procurando vaga para estacionar. Fundado em 2025, começamos com uma ideia simples mas poderosa: conectar motoristas a vagas disponíveis em tempo real.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            Desde então, temos crescido constantemente, sempre mantendo nosso compromisso com a gratuidade e qualidade do serviço. Hoje, ajudamos milhares de motoristas a encontrar vagas e proprietários a gerenciar seus estacionamentos de forma eficiente.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Nossos Valores</h2>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <span className="font-semibold mr-2" style={{ color: '#302681' }}>•</span>
              <span><strong>Gratuidade:</strong> Acreditamos que bons serviços devem ser acessíveis a todos</span>
            </li>
            <li className="flex items-start">
              <span className="font-semibold mr-2" style={{ color: '#302681' }}>•</span>
              <span><strong>Inovação:</strong> Sempre buscando novas formas de melhorar a experiência</span>
            </li>
            <li className="flex items-start">
              <span className="font-semibold mr-2" style={{ color: '#302681' }}>•</span>
              <span><strong>Transparência:</strong> Informações claras e honestas para todos</span>
            </li>
            <li className="flex items-start">
              <span className="font-semibold mr-2" style={{ color: '#302681' }}>•</span>
              <span><strong>Empreendedorismo:</strong> Apoiamos o livre mercado e a concorrência justa</span>
            </li>
          </ul>
        </section>
      </div>
    </InfoPage>
  );
};

export default QuemSomos;
